import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function WhoIsItFor() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  const forWho = ['Trabajadores con W-2 que sienten que les quitan demasiado.', 'Freelancers y contratistas 1099 que quieren bajar su AGI legalmente.', 'Padres con hijos jóvenes que ya empezaron a trabajar.', "Cualquier persona que ya hizo sus taxes este año pero siente que 'algo faltó'."];
  const notForWho = ['Personas que buscan evadir impuestos de forma ilegal.', 'Quienes no viven ni declaran impuestos en Estados Unidos.'];
  return <section className="bg-navy-light py-16 md:py-24 border-y border-white/5" data-id="element-171">
      <div ref={elementRef} className={`max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-172">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-173">
          {/* For Who */}
          <div className="bg-navy-dark p-8 rounded-2xl border border-green-500/20 shadow-lg" data-id="element-174">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-175">
              <span className="bg-green-500/20 text-green-400 p-2 rounded-lg" data-id="element-176">
                <CheckCircle2Icon className="w-6 h-6" data-id="element-177" />
              </span>
              Para quién es esto:
            </h3>
            <ul className="space-y-4" data-id="element-178">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-179">
                  <CheckCircle2Icon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-180" />
                  <span className="text-lg text-gray-300" data-id="element-181">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For Who */}
          <div className="bg-navy-dark p-8 rounded-2xl border border-red-500/20 shadow-lg" data-id="element-182">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-183">
              <span className="bg-red-500/20 text-red-400 p-2 rounded-lg" data-id="element-184">
                <XCircleIcon className="w-6 h-6" data-id="element-185" />
              </span>
              Para quién NO es esto:
            </h3>
            <ul className="space-y-4" data-id="element-186">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-187">
                  <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-188" />
                  <span className="text-lg text-gray-300" data-id="element-189">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}